import './App.css';
import MyNavBar from "./navbar/MyNavBar";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import {Home} from "./pages/Home";
import {ChangingThoughtsWithAnAI} from "./pages/ChangingThoughtsWithAnAI";
import OvercomeNegativeThought from "./pages/OvercomeNegativeThought";
import About from "./pages/About";
import {useState} from "react";
import { UserContext } from './context';
import EndActivity from "./pages/EndActivity";
import Error from "./pages/Error";

function App() {
    const [user, setUser] = useState(null);
    const basename = process.env.NODE_ENV === 'production' ? '/Cognitive-Reframing' : '/';

    return (
        <BrowserRouter basename={basename}>
            <div className="App">
                {/*<Header />*/}
                <MyNavBar/>
                    <Routes>
                        <Route path="/" exact element={<Home user={user} setUser={setUser}/>} />
                        <Route path="/changing-thoughts-with-an-ai-assistant" exact element={
                            <UserContext.Provider value={user}>
                                <ChangingThoughtsWithAnAI />
                            </UserContext.Provider>
                        } />
                        <Route path="/overcoming-negative-thoughts" exact element={
                            <UserContext.Provider value={user}>
                                <OvercomeNegativeThought />
                            </UserContext.Provider>
                        } />
                        <Route path="/end-activity" exact element={
                            <UserContext.Provider value={user}>
                                <EndActivity />
                            </UserContext.Provider>
                        } />
                        <Route path="/error" exact element={
                            <UserContext.Provider value={user}>
                                <Error />
                            </UserContext.Provider>
                        } />
                        <Route path="/about" exact element={
                            <UserContext.Provider value={user}>
                                <About />
                            </UserContext.Provider>
                        } />
                    </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
